import { Button as IrisButton, ButtonProps, ButtonVariant } from "@eworkit/iris";
import classNames from "classnames";
import React, { FC, FunctionComponent, memo } from "react";

import { Icon } from "@/components/Icon";
import { Button as EworkitButton, Flex, IButtonProps as IButton, TButtonVariant } from "@/eworkitComponents";
import { TColorVariant } from "@/style/colorVariants";

import "./_button.scss";

export interface IButtonProps extends Omit<IButton, "variant"> {
  icon?: string;
  iconColor?: TColorVariant;
  variant?:
    | ButtonVariant
    | TButtonVariant
    | "default"
    | "clean"
    | "tab"
    | "vertical-tab"
    | "vertical-icon-tab"
    | "link-danger"
    | "transparent"
    | "card-bottom";
}

/**
 * @deprecated Use iris Button instead.
 */
export const Button: FunctionComponent<IButtonProps> = memo(({ variant = "primary", ...props }) => {
  const isIrisVariant = variant === "primary" || variant === "secondary";
  const adjustedVariant = isIrisVariant ? (variant as ButtonVariant) : (variant as TButtonVariant);

  const anyChildren = props.children && React.Children.count(props.children) > 0;

  const baseClassName = "button";
  const withIconClassName = `${baseClassName}--with-icon`;
  const withoutIconColorClassName = `${baseClassName}--without-icon-color`;
  const noChildrenClassName = `${baseClassName}--no-children`;
  const className = classNames(baseClassName, props.className, {
    [withIconClassName]: props.icon,
    [withoutIconColorClassName]: !props.iconColor,
    [noChildrenClassName]: !anyChildren,
  });

  const { iconColor, type, ...buttonProps } = props;
  const ButtonAdjustedComponent = isIrisVariant ? (IrisButton as FC<ButtonProps>) : EworkitButton;

  return (
    <ButtonAdjustedComponent
      {...buttonProps}
      variant={adjustedVariant as any}
      size={buttonProps.size as any}
      type={props.type || "button"}
      className={className}>
      <Flex
        className={`${baseClassName}__button-flex`}
        align="center"
        justify="center"
        innerMargin={anyChildren ? "sm" : false}>
        {props.icon && (
          <Flex align="center" justify="center">
            {props.icon && <Icon icon={props.icon} size={props.size || "md"} color={props.iconColor || "inherit"} />}
          </Flex>
        )}
        {anyChildren && (
          <Flex className={`${baseClassName}__children-flex`} grow={1} align="center" justify="center" width={12}>
            {props.children}
          </Flex>
        )}
      </Flex>
    </ButtonAdjustedComponent>
  );
});
